// extracted by mini-css-extract-plugin
export var filterIncDec = "_eg-0";
export var leftBorder = "_eg-1";
export var rightBorder = "_eg-2";
export var stringInput = "_eg-3";